// SettingsModalButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './SettingsModalButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * SettingsModalButton
 * 
 * Displays a button for the settings modal.
 * 
 * @param {string} iconKey - The key for the button icon.
 * @param {string} label - The button label.
 * @param {Function} onClick - Callback when the button is clicked.
 *  
 * @returns {ReactNode} - SettingsModalButton.
 */
const SettingsModalButton = React.memo(({ iconKey, label, onClick }) => {

    // ----- CONTEXT ----- //
    
    // Theme Context
    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover State
    const [hovered, setHovered] = useState(false);

    // ----- HANDLERS ----- //

    /**
     * Sets hovered UI state to true.
     */
    const handleMouseEnter = () => {
        setHovered(true);
    };

    /**
     * Sets hovered UI state to false.
     */
    const handleMouseLeave = () => {
        setHovered(false);
    };

    // ----- RENDER ----- //

    return (

        <div className="settings-modal-button-container"
            style={{
                backgroundColor: hovered ? theme.backgroundHover : 'transparent',
            }}
            onClick={onClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >

            <div className="settings-modal-button-icon">
                <Icon
                    iconKey={iconKey}
                    width={16}
                    height={16}
                    color={theme.foregroundMuted}
                />
            </div>

            <div className="settings-modal-button-label"
                style={{
                    color: theme.foreground,
                }}>
                {label}
            </div>


        </div>
    );

});

// Dev Tools
SettingsModalButton.displayName = 'SettingsModalButton';

export default SettingsModalButton;

